import { defineComponent as _defineComponent } from 'vue'
import AccountDialog from '@/components/AccountDialog.vue'
import IntroductionDialog from '@/components/format-edit/IntroductionDialog.vue'
import AllPreviewDialog from '@/components/AllPreviewDialog.vue'
import LoginFormDialog from '@/components/auth/LoginFormDialog.vue'
import YagiprimeFontPaymentDialog from '@/components/Payment/YagiprimeFontPaymentDialog.vue'
import WorkgateDialog from '@/components/WorkgateDialog.vue'
import YagiBuddyDialog from '@/components/realtime-transfer/YagiBuddyDialog.vue'
import AiReasonBnr from '@/components/AiReasonBnr.vue'
import PrimeCompletePopup from '@/components/yagiprime/PrimeCompletePopup.vue'
import SkillDiagnosisPopup from '@/components/aptitude/SkillDiagnosisPopup.vue'
import AdConsentModal from '@/components/AdConsentModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppGlobalDialogs',
  props: {
    isAppWebView: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,AccountDialog, IntroductionDialog, AllPreviewDialog, LoginFormDialog, YagiprimeFontPaymentDialog, WorkgateDialog, YagiBuddyDialog, AiReasonBnr, PrimeCompletePopup, SkillDiagnosisPopup, AdConsentModal }
}

})